<template>
    <div class="nav">
        <a-menu 
            :selected-keys="selectNav" 
            :open-keys="openNav"
            mode="inline" 
            theme="dark"
            @openChange='openChange'
        >
            <template v-for="item in navList">
                <a-menu-item v-if="item.children.length==0" :key="item.path" @click="$router.push(item.path)">
                    <i class="iconfont" :class="item.ico"></i>
                    <span>{{item.name}}</span>
                </a-menu-item>
                <a-sub-menu v-if="item.children.length>0" :key="item.path">
                    <span slot="title">
                        <i class="iconfont" :class="item.ico"></i>
                        <span>{{item.name}}</span>
                    </span>
                    <a-menu-item v-for="obj in item.children" :key="obj.path"  @click="$router.push(obj.path)">{{obj.name}}</a-menu-item>
                </a-sub-menu>
            </template>
        </a-menu>
    </div>
</template>
<script>
export default {
    name:'Nav',
    data() {
        return {
            selectNav:[],
            openNav:[],
            fPath:'',
            navList:[],
        };
    },
    components: {
    },
    watch:{
    },
    mounted () {
        this.isGetNav();
    },
    watch:{
        $route(){
            this.isGetNav();
        }
    },
    methods:{
        isGetNav(){
            var to=this.$route
            var pathNum=this.getStrCount(to.path,'/');
            if(pathNum>2){
                if(this.fPath!=to.matched[1].path){
                    this.fPath=to.matched[1].path
                    this.getNav();
                }else{
                    this.navSelect();
                }
            }
        },
        getNav(){
            this.navList=[];
            var arr=this.$router.options.routes[4].children;
            for(let i=0;i<arr.length;i++){
                if(this.getStrCount(this.fPath,'/')>2){
                    if(this.fPath.indexOf(arr[i].path)>-1){
                        this.navList=arr[i].children;
                        break;
                    }
                }else{
                    if(arr[i].path==this.fPath){
                        this.navList=arr[i].children;
                        break;
                    }
                }
            }
            this.navSelect();
        },
        navSelect(){
            this.selectNav=[this.$route.path];
            this.openNav=[];
            if(this.getStrCount(this.$route.path,'/')>3){
                for(let i=0;i<this.navList.length;i++){
                    if(this.$route.path.indexOf(this.navList[i].path)>-1){
                        if(this.navList[i].children.length>0){
                            this.openNav=[this.navList[i].path];
                            if(this.getStrCount(this.$route.path,'/')>4){
                                var arr=this.navList[i].children;
                                for(let j=0;j<arr.length;j++){
                                    if(this.$route.path.indexOf(arr[j].path)>-1){
                                        this.selectNav=[arr[j].path];
                                    }
                                }
                            }
                        }else{
                            this.selectNav=[this.navList[i].path];
                        }
                        break;
                    }
                }
            }
        },
        openChange(openKeys){
            this.openNav=openKeys
        }
    }

};
</script>

<style scoped>
.nav{
    height: 100%;
    overflow-y:overlay;
    position: relative;
}
.nav::-webkit-scrollbar {
    width: 0;
    height: 100%;
    transition: all 0.3s ease-out;
}
.nav::-webkit-scrollbar-thumb {
    background-color: rgba(255,255,255,0.5);
    border-radius: 5px;
}
.nav:hover::-webkit-scrollbar {
    width: 10px;
}
</style>
